module.exports = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',
  VERTICAL_SCROLLABLE: 'verticalScrollable',

  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',
};



//////////////////
// WEBPACK FOOTER
// ./~/react-dates/constants.js
// module id = 67
// module chunks = 1